import { render, staticRenderFns, recyclableRender, components } from "./change-phone-number.vue?vue&type=template&id=f1c389fa&scoped=true&"
var renderjs
import script from "./change-phone-number.vue?vue&type=script&lang=js&"
export * from "./change-phone-number.vue?vue&type=script&lang=js&"
import style0 from "./change-phone-number.vue?vue&type=style&index=0&id=f1c389fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c389fa",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/setting/change-phone-number.vue"
export default component.exports